import { LoginOutlined, ProfileOutlined } from '@ant-design/icons';
import { Typography } from '@mui/material';

const icons = {
  LoginOutlined,
  ProfileOutlined
};

const pages = {
  id: 'authentication',
  title: (
    <Typography variant="h5" component="div">
      Authentication
    </Typography>
  ),
  type: 'group',
  children: [
    {
      id: 'login1',
      title: 'Login',
      type: 'item',
      url: '/authenticate',
      icon: icons.LoginOutlined,
      target: true
    },
    /*{
      id: 'register1',
      title: 'Register',
      type: 'item',
      url: '/register',
      icon: icons.ProfileOutlined,
      target: true
    }*/
  ]
};

export default pages;
